export const getPositionBookingCard = ({ event, isMore, isYear }) => {
  const cardWidth = isMore ? 270 : 440
  const cardHeight = isMore ? 238 : isYear ? 125 : 288
  const sideBarWidth = 260
  const topBarHeight = 64

  const newPosition = {
    x: event.clientX - cardWidth / 2,
    y: event.clientY - cardHeight / 2,
  }

  const maxX = window.innerWidth - cardWidth - sideBarWidth
  const maxY = window.innerHeight - cardHeight - topBarHeight

  newPosition.x = Math.min(Math.max(newPosition.x, 0), maxX)
  newPosition.y = Math.min(Math.max(newPosition.y, 0), maxY)

  return newPosition
}
